import React from 'react';
import { ArrowLeft } from 'lucide-react';

export default function ImpressumPage() {
  return (
    <div className="min-h-screen bg-[#050505] text-white font-body pt-24 pb-16" data-testid="impressum-page">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <a href="/" className="inline-flex items-center gap-2 text-sm text-zinc-500 hover:text-neon transition-colors mb-8" data-testid="back-home">
          <ArrowLeft className="w-4 h-4" />
          Zur&uuml;ck
        </a>

        <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white mb-12">Impressum</h1>

        <div className="prose-dark space-y-8">
          <section>
            <h2 className="font-heading text-xl font-bold text-white mb-4">Host-On Service Provider GmbH</h2>
            <p className="text-zinc-400 text-sm leading-relaxed">Stand: 02.05.2024</p>
          </section>

          <section>
            <h3 className="font-heading text-lg font-bold text-white mb-3">Hauptsitz Frankfurt am Main</h3>
            <p className="text-zinc-300 text-sm leading-relaxed">
              Hanauer Landstra&szlig;e 204<br />
              60314 Frankfurt am Main<br /><br />
              Telefon: +49 (0) 69 247 499 - 0<br />
              E-Mail: Info [at] Host-On [dot] de
            </p>
          </section>

          <section>
            <h3 className="font-heading text-lg font-bold text-white mb-3">Zweigstelle Niedersachsen</h3>
            <p className="text-zinc-300 text-sm leading-relaxed">
              Birkenallee 25<br />
              29525 Uelzen<br /><br />
              Telefon: +49 (0) 581 241 999 10
            </p>
          </section>

          <section>
            <h3 className="font-heading text-lg font-bold text-white mb-3">Registrierung</h3>
            <p className="text-zinc-300 text-sm leading-relaxed">
              Registergericht: Amtsgericht Frankfurt am Main<br />
              Registernummer: HRB 134674<br />
              USt-IdNr.: DE359953533
            </p>
          </section>

          <section>
            <h3 className="font-heading text-lg font-bold text-white mb-3">Gesch&auml;ftsf&uuml;hrung</h3>
            <p className="text-zinc-300 text-sm leading-relaxed">
              Gabriele Gohlke, Gesch&auml;ftsf&uuml;hrerin (CEO)<br />
              Philip Grassegger, Technische Leitung (CTO)<br />
              Kay Wille, Leiter Customer Support
            </p>
          </section>

          <section>
            <h3 className="font-heading text-lg font-bold text-white mb-3">Haftungsausschluss</h3>
            <p className="text-zinc-400 text-sm leading-relaxed">
              Die Verwendung der Kontaktdaten des Impressums zur Versendung gewerblicher Werbung ist ausdr&uuml;cklich nicht erw&uuml;nscht, es sei denn wir haben zuvor eine schriftliche Einwilligung erteilt oder es besteht bereits eine Gesch&auml;ftsbeziehung.
            </p>
          </section>

          <section>
            <h3 className="font-heading text-lg font-bold text-white mb-3">Haftung f&uuml;r Inhalte</h3>
            <p className="text-zinc-400 text-sm leading-relaxed">
              Die Inhalte unserer Seiten wurden mit gr&ouml;&szlig;ter Sorgfalt erstellt. F&uuml;r die Richtigkeit, Vollst&auml;ndigkeit und Aktualit&auml;t der Inhalte k&ouml;nnen wir jedoch keine Gew&auml;hr &uuml;bernehmen.
            </p>
          </section>

          <section>
            <h3 className="font-heading text-lg font-bold text-white mb-3">Haftung f&uuml;r Links</h3>
            <p className="text-zinc-400 text-sm leading-relaxed">
              Unser Angebot enth&auml;lt Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben.
            </p>
          </section>

          <section>
            <h3 className="font-heading text-lg font-bold text-white mb-3">Streitbeilegung</h3>
            <p className="text-zinc-400 text-sm leading-relaxed">
              Die EU-Kommission stellt eine Plattform zur Online-Streitbeilegung bereit:{' '}
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-neon hover:underline">
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
          </section>

          <section>
            <h3 className="font-heading text-lg font-bold text-white mb-3">Urheberrecht</h3>
            <p className="text-zinc-400 text-sm leading-relaxed">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
